"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _dummyReviews = require("../../constants/reviews/dummyReviews");

var LIST_QUERIES = _interopRequireWildcard(require("../../constants/reviews/ReviewsListQueries"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIProgress = _interopRequireDefault(require("UIComponents/progress/UIProgress"));

var _colors = require("HubStyleTokens/colors");

var _ReviewStats = _interopRequireDefault(require("../../records/ReviewStats"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 14px;\n  font-weight: 600;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Number = _styledComponents.default.span.withConfig({
  displayName: "OverallDistribution__Number",
  componentId: "ta8bed-0"
})(_templateObject());

var OverallDistribution = function OverallDistribution(_ref) {
  var reviewStats = _ref.reviewStats,
      width = _ref.width,
      onFilterChange = _ref.onFilterChange,
      heading = _ref.heading;
  var percentages = reviewStats.getOverallPercentages().toJS();
  var validFilters = (0, _react.useMemo)(function () {
    return reviewStats.getValidRatingFilters();
  }, [reviewStats]);

  var renderRatingRow = function renderRatingRow(stars, value) {
    // e.g THREE_STARS, ONE_STAR, etc.
    var stateValue = LIST_QUERIES.STAR_NUM_TO_STATE.get(stars);
    var isDisabledValue = !validFilters.has(stateValue);

    var onClick = function onClick() {
      return onFilterChange({
        target: {
          value: stateValue
        }
      });
    };

    return _react.default.createElement(_UIFlex.default, {
      key: stars,
      className: "m-bottom-0",
      align: "center",
      justify: "between"
    }, _react.default.createElement("span", {
      style: {
        width: 36
      }
    }, _react.default.createElement(_UIButton.default, {
      use: "link",
      onClick: onClick,
      disabled: isDisabledValue
    }, _react.default.createElement(Number, null, stars), _react.default.createElement(_UIIcon.default, {
      className: "m-x-1",
      name: "favorite",
      color: _colors.MARIGOLD,
      size: "xxs"
    }))), _react.default.createElement("span", {
      className: "m-right-2 flex-grow-1 display-inline-block"
    }, _react.default.createElement(_UIProgress.default, {
      style: {
        background: _colors.SLINKY
      },
      wrapperClassName: "m-bottom-0",
      value: value
    })), _react.default.createElement("span", {
      style: {
        width: 50
      }
    }, _react.default.createElement(_UIButton.default, {
      use: "link",
      onClick: onClick,
      disabled: isDisabledValue
    }, _react.default.createElement(Number, null, value + "%"))));
  };

  return _react.default.createElement("div", {
    style: {
      width: width
    }
  }, _react.default.createElement(_H.default, null, heading || _react.default.createElement(_FormattedMessage.default, {
    message: "ecosystemMarketplaceCore.reviews.overallDistribution"
  })), Object.keys(percentages).reverse().map(function (star) {
    return renderRatingRow(star, percentages[star]);
  }));
};

OverallDistribution.propTypes = {
  reviewStats: _propTypes.default.instanceOf(_ReviewStats.default).isRequired,
  width: _propTypes.default.number,
  onFilterChange: _propTypes.default.func,
  heading: _propTypes.default.node
};
OverallDistribution.defaultProps = {
  reviewStats: _dummyReviews.dummyReviewStats,
  width: 300,
  onFilterChange: function onFilterChange() {}
};
var _default = OverallDistribution;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/OverallDistribution.js
// module id = 850
// module chunks = 209 210 211 212